import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useAuth } from '../context/AuthContext.jsx'
import { formatRub } from '../lib/format.js'
import CoinIcon from './CoinIcon.jsx'
import '../styles/header.css'

const NAV = [
  {
    to: '/cases',
    label: 'Кейсы',
    icon: (
      <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
        <path d="m3.3 7 8.7 5 8.7-5" />
        <path d="M12 22V12" />
      </svg>
    ),
  },
  {
    to: '/upgrade',
    label: 'Апгрейд',
    icon: (
      <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="17 11 12 6 7 11" />
        <polyline points="17 17 12 12 7 17" />
      </svg>
    ),
  },
  {
    to: '/crafts',
    label: 'Крафты',
    icon: (
      <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="m16 3 4 4-4 4" />
        <path d="M20 7H9a4 4 0 0 0-4 4v1" />
        <path d="m8 21-4-4 4-4" />
        <path d="M4 17h11a4 4 0 0 0 4-4v-1" />
      </svg>
    ),
  },
]

export default function Header() {
  const { user, logout } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)

  const close = () => setMenuOpen(false)

  const handleLogout = () => {
    logout()
    close()
    navigate('/')
  }

  return (
    <header className="site-header">
      <div className="container site-header-inner">
        {/* Логотип CaseMania */}
        <Link to="/" className="brand" onClick={close} title="CaseMania — на главную">
          <img src="/cmlogo.png" alt="CaseMania" className="brand-logo-img" />
        </Link>

        {/* Навигационное меню в стиле musor.best */}
        <nav className={`site-nav ${menuOpen ? 'is-open' : ''}`}>
          {NAV.map((link) => {
            const isActive =
              link.to === '/cases'
                ? location.pathname === '/' || location.pathname.startsWith('/cases') || location.pathname.startsWith('/case') || location.pathname.startsWith('/containers')
                : location.pathname.startsWith(link.to)

            return (
              <Link
                key={link.to}
                to={link.to}
                onClick={close}
                className={`nav-link ${isActive ? 'is-active' : ''}`}
              >
                <span className="nav-link-icon">{link.icon}</span>
                <span className="nav-link-text">{link.label}</span>
                {isActive && <span className="nav-link-indicator" aria-hidden="true" />}
              </Link>
            )
          })}
        </nav>

        {/* Правая часть: баланс + профиль или Steam Login */}
        <div className="site-header-actions">
          {user ? (
            <>
              <Link to="/deposit" className="balance-chip" onClick={close} title="Пополнить баланс">
                <span className="balance-amount">{formatRub(user.balance)}</span>
                <CoinIcon size="sm" className="balance-coin-icon" />
                <span className="balance-plus" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </span>
              </Link>

              <div className="user-menu">
                <Link to="/profile" className="user-chip" onClick={close} title="Личный профиль">
                  {user.avatar ? (
                    <img src={user.avatar} alt={user.username} className="user-avatar-img" />
                  ) : (
                    <span className="user-avatar">{user.username.slice(0, 1).toUpperCase()}</span>
                  )}
                  <span className="user-name">{user.username}</span>
                </Link>

                <button
                  type="button"
                  className="btn-header-logout"
                  onClick={handleLogout}
                  title="Выйти из аккаунта"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                </button>
              </div>
            </>
          ) : (
            <a href="/api/auth/steam" className="btn-steam" onClick={close}>
              <svg className="steam-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M11.979 0C5.678 0 .511 4.86.022 11.037l6.432 2.658c.545-.371 1.203-.59 1.912-.59.063 0 .125.004.188.006l2.861-4.142V8.91c0-2.495 2.028-4.524 4.524-4.524 2.494 0 4.524 2.031 4.524 4.527s-2.03 4.525-4.524 4.525h-.105l-4.076 2.911c0 .052.005.105.005.159 0 1.875-1.515 3.396-3.39 3.396-1.635 0-3.016-1.173-3.331-2.727L.436 15.27C1.862 20.307 6.486 24 11.979 24c6.627 0 12-5.373 12-12S18.605 0 11.979 0z" />
              </svg>
              <span>Войти через Steam</span>
            </a>
          )}

          {/* Бургер для мобильных экранов */}
          <button
            type="button"
            className="burger"
            aria-label="Меню навигации"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  )
}
